import { Navigate, Outlet} from "react-router-dom";
import { useAuth } from "./authContext";
import { AuthContextState } from "../../utils/types";
import pathConstant from "../../utils/path.constant";
import React from "react";
import Loading from "../../components/pages/Loading";

const IsAuthRoutes : React.FC = () =>{
    const {isAuthenticated, loading} = useAuth() as AuthContextState;

    if(loading) {
        return(
            <Loading />
        );
    }
    const protectedLocation = localStorage.getItem('lastProtectedRouted');
    const lastLocation = protectedLocation ? protectedLocation : pathConstant.DASHBOARD;

    return isAuthenticated ? <Navigate to={lastLocation} /> : <Outlet />
}

export default IsAuthRoutes;